<style>
    .fullpage {
        flex-grow: 1;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .logo {
        margin-right: 2em;
    }
</style>

<div class="fullpage">
    <span class="logo">ksuite pb</span>
    <a href="/auth/oauth2">
        <span>sign in</span>
        <i class="fas fa-arrow-right"></i>
    </a>
</div>
